<template lang="pug"> 
  v-btn(
    type='submit'
    :disabled='loading || disabled'
    :loading='loading'
    :color="colorDefault"
    depressed
    :block="block"
    :dark="!loading"
    @click='$emit("click")'
  ) 
    slot

</template>
<script>
import ButtonMixin from '@/mixins/Button'
export default {
  mixins : [ButtonMixin],
  computed: {
    colorDefault () {
      return this.color || 'var(--bg-secondary-color)'
    }
  }
}
</script>